module.exports = "<label class=\"switch\">\n    <input type=\"checkbox\" [checked]=\"data\" disabled>\n    <span class=\"slider round\"></span>\n</label>"


//////////////////
// WEBPACK FOOTER
// ./libs/chassis-datatable/src/components/values/boolean/boolean.component.html
// module id = ./libs/chassis-datatable/src/components/values/boolean/boolean.component.html
// module chunks = main